import { observer } from "mobx-react";
import useFeature from "../../../useFeature";
import { useApplication } from "../../../ApplicationProvider";
import SalesByChannelFeature from "./SalesByChannelFeature";
import SalesByCustomerFeature from "./SalesByCustomerFeature";
import SalesByGroupTable from "./SalesByGroupTable";
import SalesByMixTable from "./SalesByMixTable";

function SalesByChannelChart({ filters, boxesMode, zoomedChannel, onZoomIntoChannel, onExitChannelZoom }) {
    const application = useApplication();
    const channelFeature = useFeature(
        () => new SalesByChannelFeature(application, filters),
        [application, JSON.stringify(filters)]
    );
    const customerFeature = useFeature(
        () => new SalesByCustomerFeature(application, filters),
        [application, JSON.stringify(filters)]
    );

    const isZoomed = !!zoomedChannel;

    if (isZoomed) {
        return (
            <SalesByMixTable
                title="Ventas por Canal"
                groupHeader="Cliente"
                loaded={!!customerFeature?.loaded}
                data={customerFeature?.salesByCustomer}
                boxesMode={boxesMode}
                breadcrumb={{ root: "Canales", leaf: zoomedChannel, onExit: onExitChannelZoom }}
            />
        );
    }

    return (
        <SalesByGroupTable
            title="Ventas por Canal"
            groupHeader="Canal"
            loaded={!!channelFeature?.loaded}
            data={channelFeature?.salesByChannel}
            boxesMode={boxesMode}
            onGroupClick={onZoomIntoChannel}
        />
    );
}

export default observer(SalesByChannelChart);
